// @ts-nocheck



import React, { Component, Fragment } from 'react';
import styled, { css } from 'styled-components';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import { Item as FormItem } from 'antd/lib/form';
import notification from 'antd/lib/notification';


import { Icon as UiIcon } from '../../../components/ui';
import { notificationLoading } from '../../../components/Notifications';
import { InputNumber } from '../../../components/inputs';

const ItemCol = styled.div.withConfig({ displayName: "RepairOrderVehicleEditRow__ItemCol", componentId: "sc-1j8vzmi-0" })(["", ";"],
(props) => css(["", ";"],
props.width ? `width: ${props.width}px;` : `flex: ${props.flex || 1};`));



const Wrapper = styled.div.withConfig({ displayName: "RepairOrderVehicleEditRow__Wrapper", componentId: "sc-1j8vzmi-1" })(["display:flex;flex-direction:row;box-sizing:border-box;align-items:flex-start;> .col-item{padding:0 8px;text-align:left;vertical-align:middle;&:first-child{padding-left:0;}&:last-child{padding-right:0;}}"]);



















const OperationCol = styled(ItemCol).withConfig({ displayName: "RepairOrderVehicleEditRow__OperationCol", componentId: "sc-1j8vzmi-2" })(["height:32px;"]);



const StyledIcon = styled(UiIcon).withConfig({ displayName: "RepairOrderVehicleEditRow__StyledIcon", componentId: "sc-1j8vzmi-3" })(["margin-top:8px;cursor:pointer;"]);














/**
 * Строка редактирования ремонта ТС
 */
export default class RepairOrderOperationRow extends Component {
  state = {
    repairOrderOperation: this.props.repairOrderOperation || {},
    errors: {}
  };

  componentDidMount() {
    !isEmpty(this.props.repairOrderOperation) && this.validate();
  }

  componentDidUpdate(prevProps) {
    if (
    !isEqual(prevProps.repairOrderOperation, this.props.repairOrderOperation))
    {
      this.setState(
        {
          repairOrderOperation: this.props.repairOrderOperation
        },
        () => this.validate()
      );
    }
  }

  validate = () => {
    const { repairOrderOperation } = this.state;
    var errors = {};
    if (!repairOrderOperation.count) {
      errors.count = 'Обязательно для заполнения';
    }
    this.setState({
      errors
    });
    return errors;
  };

  updateRepairOrderOperation = () => {
    const errors = this.validate();
    if (isEmpty(errors)) {
      try {
        notificationLoading({
          message: 'Сохранение данных...',
          key: 'saving'
        });
        this.props.onChange &&
        this.props.onChange(this.state.repairOrderOperation);
      } catch (err) {
        console.warn(err.message);
      } finally {
        notification.destroy('saving');
      }
    }
  };

  onChange = (repairOrderOperation) =>
  this.setState(
    {
      repairOrderOperation
    },
    () => this.updateRepairOrderOperation()
  );

  render() {
    const { onDelete } = this.props;
    const { repairOrderOperation, errors } = this.state;
    return (
      <Fragment>
        <Wrapper className="list-row-item">
          <ItemCol
            flex={1}
            className="col-item"
            style={{ maxWidth: 'calc(100% - 500px)' }}>

            {repairOrderOperation.operation ?
            repairOrderOperation.operation.name :
            ''}
          </ItemCol>
          <ItemCol flex={1} className="col-item">
            <FormItem
              validateStatus={errors.count && 'error'}
              help={errors.count}>

              <InputNumber
                min={1}
                value={repairOrderOperation.count}
                onChange={(count) =>
                // $FlowFixMe не хватает параметров
                this.onChange({ ...repairOrderOperation, count })
                } />

            </FormItem>
          </ItemCol>
          <OperationCol width={35} className="col-item">
            {onDelete &&
            <StyledIcon
              type="x"
              onClick={() => onDelete(repairOrderOperation)} />

            }
          </OperationCol>
        </Wrapper>
      </Fragment>);

  }
}
